import React from "react";
import { links } from "../data/content";
export function Footer() {
  return <footer className="border-t border-line px-6 py-10 text-center text-sm text-soft" data-id="element-50" data-mp="3gezcj1s77n03">
      <p className="font-serif text-lg text-accent" data-id="element-51" data-mp="32nukakr5twzs">Marcos Rosell · Radar Digital</p>
      <a href={links.instagram} target="_blank" rel="noopener noreferrer" className="mt-3 inline-block transition-colors duration-150 hover:text-white" data-id="element-52" data-mp="32lrmhejrmzki">
        Consultas: @marketingconmarcos
      </a>
      <p className="mt-4" data-id="element-53" data-mp="398y6cw8527j">© 2026 Marketing con Marcos</p>
    </footer>;
}